import { render, staticRenderFns } from "./TherapistSelect.vue?vue&type=template&id=47baa4b4&scoped=true&"
import script from "./TherapistSelect.vue?vue&type=script&lang=js&"
export * from "./TherapistSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47baa4b4",
  null
  
)

export default component.exports